import { Formik } from "formik";
import Header from "../components/Header";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import SubHeader from "../components/SubHeader";
import DatePicker from "react-multi-date-picker";
import { pageRoutes } from "../routes/PageRoutes";
import React, { useEffect, useMemo, useState } from "react";
import ErrorMessage from "../components/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import GuidedTour from "../components/GuidedTour";
import { setTourStep } from "../redux/reducers/tourReducer";
import { getDockData, assignBoatToDock } from "../redux/actions/staffActions";
const AssignDock2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const boatDetails = useLocation()?.state?.data || {};
  const { isLoading1, all_docks } = useSelector(
    (state) => state?.staffReducer,
  );
  const tooltipSeen = useSelector((state) => state?.authReducer?.tooltipSeen);
  const { active: isTourActive, step: tourStep } = useSelector(
    (state) => state?.tourReducer,
  );
  const [isToggle, setIsToggle] = useState(false);
  const [dateValue, setDateValue] = useState();
  const [dateError, setDateError] = useState("");
  const [disabledRanges, setDisableRages] = useState([]);
  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  const disableDates = (val) => {
    if (val?.length != 0) {
      let data = [];
      val?.map((item) =>
        data.push({
          start: new Date(new Date(item?.from).setHours(0, 0, 0, 0)),
          end: new Date(new Date(item?.to).setHours(23, 59, 59, 999)),
        }),
      );
      setDisableRages(data);
    } else {
      setDisableRages([]);
    }
  };

  const disableMultiRanges = (currentDate) => {
    const jsDate = currentDate.toDate();
    return disabledRanges.some((range) => {
      return jsDate >= range.start && jsDate <= range.end;
    });
  };

  useEffect(() => {
    dispatch(getDockData());
  }, []);

  const toYMD = (value) => {
    const rawDate = value?.toDate ? value.toDate() : value;
    const date = rawDate instanceof Date ? rawDate : new Date(rawDate);
    if (Number.isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  };

  const handleBoatAssign = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);

    if (!values.dockId) {
      setDateError("Please select a dock");
      return;
    }

    if (!boatDetails?.id) {
      setDateError("Boat not found. Please go back and try again.");
      return;
    }

    if (!dateValue || dateValue.length < 2) {
      setDateError("Please select date range");
      return;
    }

    const payload = {
      dockId: Number(values.dockId),
      boatId: Number(boatDetails?.id),
      book_from: toYMD(dateValue[0]),
      book_to: toYMD(dateValue[dateValue.length - 1]),
    };

    const callback = (response) => {
      if (response?.success) {
        resetForm();
        setDateValue([]);
        setDateError("");
        navigate(pageRoutes?.boat_docks);
      }
    };

    dispatch(assignBoatToDock({ payload, callback }));
  };

  const handleSelection = (selectedDates) => {
    if (!selectedDates.length) {
      setDateValue([]);
      return;
    }
    const sortedDates = selectedDates.sort((a, b) => a - b);
    const firstDate = sortedDates[0];
    const lastDate = sortedDates[sortedDates.length - 1];
    const newSelection = [];
    let isBlocked = false;
    for (
      let current = new Date(firstDate);
      current <= lastDate && !isBlocked;
      current.setDate(current.getDate() + 1)
    ) {
      const dateObject = new Date(current);
      if (disableMultiRanges({ toDate: () => dateObject })) {
        isBlocked = true;
        break;
      }
      newSelection.push(new Date(dateObject));
    }
    setDateError("");
    if (newSelection?.length > 1) {
      const date_selected = [
        newSelection[0],
        newSelection[newSelection?.length - 1],
      ];
      setDateValue(date_selected);
    } else {
      setDateValue(newSelection);
    }
  };

  const [run, setRun] = useState(false);
  // const tourCompletedKey = "assign_boat_formkey";
  // const getStep = () => Number(localStorage.getItem("tour_step") || 0);
  // const setStep = (step) => localStorage.setItem("tour_step", step);
  // const completeTour = () => {
  //   localStorage.setItem(tourCompletedKey, "true");
  //   localStorage.removeItem("tour_step");
  // };

  const steps = useMemo(
    () => [
      {
        target: ".assign_boat_btn",
        spotlightTarget: ".assign_boat_wrapper",
        title: "Assign a dock",
        content:
          "Choose the dock where this boat will be placed, review the details, and proceed.",
        placement: "bottom",
        nextLabel: "Next",
        skipLabel: "Skip",
        showSkipButton: true,
        className: "admewDocform",
      },
    ],
    [],
  );

  // useEffect(() => {
  //   const isAssignBoatTourCompleted =
  //     localStorage.getItem(tourCompletedKey) === "true";
  //   const step = getStep();

  //   if (!isAssignBoatTourCompleted && (step === 6 || step === 1 || step === 0)) {
  //     const interval = setInterval(() => {
  //       const el = document.querySelector(".assign_boat_form");

  //       if (el) {
  //         setRun(true);
  //         clearInterval(interval);
  //       }
  //     }, 100);

  //     return () => clearInterval(interval);
  //   }
  // }, [tourCompletedKey]);

  useEffect(() => {
    if (tooltipSeen === true) {
      setRun(false);
      return undefined;
    }

    if (!isTourActive || tourStep !== 6) {
      setRun(false);
      return undefined;
    }

    const interval = setInterval(() => {
      const el = document.querySelector(".assign_boat_btn");
      if (el) {
        setRun(true);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [isTourActive, tooltipSeen, tourStep]);

  if (isLoading1) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      {/* <GuidedTour
        steps={steps}
        run={run}
        onSkip={() => {
          setRun(false);
          completeTour();
        }}
        onComplete={() => {
          setRun(false);
          setStep(7);
          navigate(pageRoutes?.dashboard);
        }}
      /> */}
      <GuidedTour
        steps={
          tooltipSeen === true || !isTourActive || tourStep !== 6 ? [] : steps
        }
        run={run && tooltipSeen !== true && isTourActive && tourStep === 6}
        markSeenApi={false}
        onSkip={() => setRun(false)}
        onComplete={() => {
          setRun(false);
          dispatch(setTourStep(7));
          navigate(pageRoutes.dashboard);
        }}
      />
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar  />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div className="ct_px_23 ct_mt_30 pb-5">

            <div className="ct_mb_30">
              <SubHeader />
            </div>
            <Formik
              initialValues={{
                dockId: "",
              }}
              onSubmit={(values, actions) => {
                handleBoatAssign(values, actions);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                resetForm,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="assign_boat_wrapper">
                    <div className="ct_white_bg_1 pb-5 assign_boat_form">
                      <div className="row">
                        
                        {/* Dock Selection */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Dock Selection{" "}
                              <span className="ct_required_star">*</span>
                            </label>

                            <select
                              className="form-control ct_input ct_transparent_input ct_pointer_curser"
                              id="dockId"
                              name="dockId"
                              value={values.dockId}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                const selectedDockId = Number(e.target.value);
                                const selectedDock = all_docks?.find(
                                  (d) => Number(d?.id) === selectedDockId,
                                );
                                disableDates(selectedDock?.bookedDates);
                                setDateValue([]);
                                setDateError("");
                              }}
                            >
                              <option value="">----Select Dock----</option>

                              {all_docks?.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>

                            <ErrorMessage
                              className="d-block"
                              errors={errors}
                              touched={touched}
                              fieldName="dockId"
                            />
                          </div>
                        </div>

                        {/* Date Range */}
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Select Date Range{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <div className="d-flex gap-2 ct_flex_wrap_575 position-relative">
                              <DatePicker
                                placeholder="----Select Date Range----"
                                className="form-control "
                                style={{ cursor: "pointer" }}
                                mapDays={({ date, disabled }) => {
                                  const isDisabled = disableMultiRanges(date);
                                  return {
                                    disabled: isDisabled || disabled,
                                    style: isDisabled
                                      ? {
                                        backgroundColor: "#ccc",
                                        color: "#fff",
                                      }
                                      : undefined,
                                  };
                                }}
                                value={dateValue ?? ""}
                                range={true}
                                minDate={
                                  new Date()?.toISOString()?.split("T")[0]
                                }
                                rangeHover={false}
                                numberOfMonths={2}
                                onChange={handleSelection}
                              />
                              <i className="fa-regular fa-calendar ct_date_icon_top_123"></i>
                            </div>
                            <span style={{ color: "red" }}>{dateError}</span>
                          </div>
                        </div>

                        {/* Date Error */}
                        {/* {setDateError && (
                          <div className="col-12">
                            <span style={{ color: "red" }}>{setDateError}</span>
                          </div>
                        )} */}
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex justify-content-end gap-3 ct_mt_40">
                      <button
                        type="button"
                        onClick={() => {
                          setDateValue([]);
                          resetForm();
                          setDateError("");
                        }}
                        className="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn"
                      >
                        Cancel
                      </button>

                      <button
                        type="submit"
                        className="ct_border_radius_5 ct_h_40 ct_orange_btn assign_boat_btn"
                      >
                        Assign Boat
                      </button>
                    </div>
                  </div>
                </form> 
              )}
            </Formik>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignDock2;


